'use client';

import { RefObject } from 'react';

import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';

interface MountFadeUpAnimationProps {
  triggerRef: RefObject<HTMLDivElement | null>;
  delay?: number;
}

const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined') return false;

  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

const useMountFadeUpAnimation = ({ triggerRef, delay = 0 }: MountFadeUpAnimationProps) => {
  useGSAP(
    () => {
      const container = triggerRef.current;

      if (!container) return;

      if (prefersReducedMotion()) {
        gsap.set(container, { autoAlpha: 1, y: 0 });

        return;
      }

      gsap.set(container, { autoAlpha: 0, y: 100 });
      gsap.to(container, {
        duration: 1,
        autoAlpha: 1,
        y: 0,
        ease: 'power2.out',
        delay,
        force3D: true,
      });
    },
    { scope: triggerRef }
  );
};

export default useMountFadeUpAnimation;
